export function isValueNullOrEmpty(value) {
  return value === "" || value === null;
}
